export const defaultTableFilters = {
  per_page: 20,
  sort_dir: "asc",
  handlePagination: true,
};
